import { BANK_SLIP_ENTRY_REQUEST, CREATE_BANK_SLIP_ENTRY, GET_BANK_SLIP_ENTRIES, UPDATE_BANK_SLIP_ENTRY, DELETE_BANK_SLIP_ENTRY, BANK_SLIP_ENTRY_REQUEST_FAILURE, GET_AVAILABLE_BANK_RECEIPT_TRANSACTION, GET_BANK_SLIP_ENTRY_PAGE, BANK_SLIP_ENTRY_REQUEST_SUCCESS } from '../types';

const initialState = {
  bankSlipEntries: [],
  bankSlipEntriesPage: [],
  availableRecieptTransactions: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const bankSlipEntryReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_SLIP_ENTRY_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_SLIP_ENTRIES: {
      return {
        ...state,
        bankSlipEntries: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_BANK_SLIP_ENTRY_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        bankSlipEntriesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case GET_AVAILABLE_BANK_RECEIPT_TRANSACTION: {
      return {
        ...state,
        availableRecieptTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_BANK_SLIP_ENTRY:
      return {
        ...state,
        bankSlipEntries: [action.payload, ...state.bankSlipEntries],
        loading: false,
        error: null
      };
    case UPDATE_BANK_SLIP_ENTRY:
      const bankSlipEntriesData = state.bankSlipEntries.slice(0);
      const uIndex = bankSlipEntriesData.findIndex((data) => data.id === action.payload.id);
      bankSlipEntriesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        bankSlipEntries: [ ...bankSlipEntriesData ],
        loading: false,
        error: null
      };
    case DELETE_BANK_SLIP_ENTRY:
      const bankSlipEntries = state.bankSlipEntries?.slice(0);
      const index = bankSlipEntries.findIndex((data) => data.id === action.id);
      if (index > -1) {
        bankSlipEntries.splice(index, 1);
      }
      return {
        ...state,
        bankSlipEntries: [...bankSlipEntries],
        loading: false,
        error: null
      }
    case BANK_SLIP_ENTRY_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
    case BANK_SLIP_ENTRY_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankSlipEntryReducer;